import { apiFetch } from './apiFetch';

// ─── Types ───────────────────────────────────────────────────────────────

export interface PaymentInitResponse {
  paymentUrl: string;
  paymentId: string;
  depositAmount: number;
}

export interface PaymentStatusResponse {
  bookingId: string;
  status: string;
  paymentStatus: string;
  paymentGateway: string;
  totalPrice: string;
  depositAmount: string | null;
  molliePaymentId: string | null;
  mollieRefundId: string | null;
  mollieStatus?: string | null;
  mollieError?: string;
  expiresAt?: string | null;
  securityDeposit?: {
    amount: number;
    method: 'MANUAL' | 'BANK_TRANSFER' | 'CARD_CHARGE' | 'CARD_HOLD' | null;
    status: 'NOT_REQUIRED' | 'PENDING' | 'HELD' | 'CHARGED' | 'REFUNDED' | 'RELEASED' | 'FAILED';
    paymentId?: string | null;
    refundId?: string | null;
    chargedAt?: string | null;
    releasedAt?: string | null;
  };
}

export interface RefundResponse {
  message: string;
  refundId: string;
  refundAmount: number;
}

// ─── Initiate Payment ────────────────────────────────────────────────────

export async function initiatePayment(bookingId: string): Promise<PaymentInitResponse> {
  return apiFetch('/payments/create', {
    method: 'POST',
    body: JSON.stringify({ booking_id: bookingId }),
  });
}

// ─── Get Payment Status ──────────────────────────────────────────────────

export async function getPaymentStatus(bookingId: string): Promise<PaymentStatusResponse> {
  return apiFetch(`/payments/${bookingId}/status`);
}

// ─── Initiate Refund ─────────────────────────────────────────────────────

export async function initiateRefund(bookingId: string): Promise<RefundResponse> {
  return apiFetch(`/payments/${bookingId}/refund`, {
    method: 'POST',
  });
}
